// Constants shared by the blog editor and renderer.
//
// Extracted from BlogsPage.js (and de-duplicated from BlogElementRenderer.js,
// which previously held an identical copy of BLOG_ELEMENT_PADDING).

/**
 * Padding (in pixels) applied to blog elements in the editor preview and
 * rendered output. Text-like elements use `left`/`right`; media elements
 * (image/video/offer) use `mediaLeft`/`mediaRight`.
 */
export const BLOG_ELEMENT_PADDING = {
  top: 10,      // Top padding for all elements
  bottom: 0,    // Bottom padding for all elements
  left: 10,     // Left padding for text/title/button elements
  right: 10,    // Right padding for text/title/button elements
  mediaLeft: 0, // Left padding for image/video/offer elements
  mediaRight: 0 // Right padding for image/video/offer elements
};

/**
 * Mobile preview frame dimensions (iPhone 11 proportions, in pixels).
 * Used by the editor's mobile preview and by page-height calculations.
 */
export const MOBILE_PHONE_WIDTH = 414;
export const MOBILE_PHONE_HEIGHT = 750;
